import { Grid } from "@mui/material";
import { MprcContainer, MprcRequestIndicator } from "components";
import { UserOperationSettingsResponse, UserOperationType } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { BroadcastMessageStepProps } from "views/foundation/broadcastMessage/Home";
import { SearchUsersBox } from "views/foundation/broadcastMessage/Home/StepDestination/SearchUsersBox";
import { SelectedUsersBox } from "views/foundation/broadcastMessage/Home/StepDestination/SelectedUsersBox";
import { useBroadcastMessageContext } from "views/foundation/broadcastMessage/Home/StepManagement";

export const StepDestination: React.FC<BroadcastMessageStepProps> = ({ setCanSave }) => {

  const api = useCoreApi();
  const ctx = useBroadcastMessageContext();

  const [loading, setLoading] = useState<boolean>(false);
  const [settings, setSettings] = useState<UserOperationSettingsResponse>({
    customFields: [],
    isWorkplaceFreeText: true,
    locale: "",
    workplaceLabel: "",
    secondaryManagers: [],
    blockReasons: [],
    unitTypes: []
  });
  const [reloadSelectedUsers, setReloadSelectedUsers] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api.v1.userOperation.getSettings({ operation: UserOperationType.BroadcastMessage })
      .then(response => setSettings(response.data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setCanSave((ctx.selectedUsers?.totalRows ?? 0) > 0 || ctx.message.allActiveUsers == true);
  }, [ctx.selectedUsers]);

  return <MprcContainer>
    <MprcRequestIndicator visible={loading} type={"request"} />
    <Grid container spacing={3} wrap="nowrap">
      {!ctx.message.allActiveUsers &&
        <Grid size={{ xs: 8 }}>
          <SearchUsersBox
            onReloadSelectedUsers={() => setReloadSelectedUsers(true)}
            settings={settings}
          />
        </Grid>
      }
      <Grid size={{ xs: !ctx.message.allActiveUsers ? 4 : 12 }}>
        <SelectedUsersBox
          reload={reloadSelectedUsers}
          onFinishReload={() => setReloadSelectedUsers(false)}
        />
      </Grid>
    </Grid>
  </MprcContainer>;
};